













































































































































































import { Vue, Component } from 'vue-property-decorator';
import {
  FmvDrawerLayout,
} from 'fmv-layout';
import {FmvAvatar} from 'fmv-avatar';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';
import i18nDropdown from '../../components/vui-luma/Ui/i18nDropdown.vue';
import {dispatchGetDropdownMenu, dispatchUserLogOut} from '@/store/main/actions';
import {readDropdownMenu, readUserProfile} from '@/store/main/getters';

@Component({
  components: {
    FmvDrawerLayout,
    FmvAvatar,
    MdIcon,
    i18nDropdown,
  },
})
export default class Navbar extends Vue {
  public navbarVariant = 'white navbar-shadow'; // 'body border-bottom-2';
  public navbarType = 'light';
  public navbarClass = 'navbar navbar-light bg-body border-bottom-2 navbar-expand mdk-header--fixed mdk-header--shadow';
  public navbarToggleClass = null;
  public navbarContainerClass = 'd-flex w-100 align-items-center';

  get isLoggedIn() {
    return this.$store.state.main.isLoggedIn;
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }

  public toggleSidebar() {
    const sidebar = document.getElementById('default-drawer');
    // @ts-ignore
    if (!sidebar.getAttribute('data-opened')) {
      // @ts-ignore
      sidebar.setAttribute('data-opened', true);
    } else {
      // @ts-ignore
      sidebar.removeAttribute('data-opened');
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public copyPromo() {
    const testingCodeToCopy = document.querySelector('#promo-input');
    // @ts-ignore
    testingCodeToCopy.setAttribute('type', 'text');
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      const range = document.createRange();
      // @ts-ignore
      range.selectNode(testingCodeToCopy);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    } else {
      // @ts-ignore
      testingCodeToCopy.select();
    }


    try {
      const successful = document.execCommand('copy');
      // @ts-ignore
      this.$noty.error(this.$t('Link copied'));
    } catch (err) {
      // @ts-ignore
      this.$noty.error(this.$t('Copy error'));
    }
    // @ts-ignore
    testingCodeToCopy.setAttribute('type', 'hidden');
    // @ts-ignore
    window.getSelection().removeAllRanges();
  }

  public async mounted() {
    await dispatchGetDropdownMenu(this.$store);
  }

  get dropdownMenu() {
    return readDropdownMenu(this.$store);
  }
  public async handleOpenExternalLink(url) {
    if (url !== '') {
      window.open(url, '_blank');
    }
  }
}
